function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Keyboard, ScrollView } from "react-native";
import { Button } from "./Button";
import { ModalContainer } from "./ModalContainer";
import { OldHeading } from "./Text";
import { View } from "./View";
import { useTheme } from "../styles";
/**
 * Modal that cannot be dismissed via standard cancel actions as it requires
 * custom dismissal logic for the specific use case. The parent component is
 * responsible for dismissing the modal when appropriate.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-89}
 */ export function MandatoryModal(props) {
    var Shadow = useTheme().Shadow;
    return /*#__PURE__*/ _jsx(ModalContainer, {
        visible: props.visible,
        onRequestClose: function() {},
        style: [
            {
                width: '90%',
                maxWidth: 400,
                backgroundColor: 'white',
                marginHorizontal: 10,
                borderRadius: 20,
                paddingVertical: 26,
                paddingHorizontal: 12
            },
            Shadow.high
        ],
        children: props.children
    });
}
/**
 * Container element for modal children views that allow children to render as
 * full width instead of being narrowed by padding.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-93}
 */ export function ModalContainerFullWidth(props) {
    return /*#__PURE__*/ _jsx(View, {
        style: {
            marginHorizontal: -20
        },
        children: props.children
    });
}
/**
 * Standard component for rendering UI in a popup modal.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-95}
 */ export function Modal(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    var theme = useTheme().theme;
    var _props_maxWidth;
    return /*#__PURE__*/ _jsxs(ModalContainer, _object_spread_props(_object_spread({}, props), {
        style: {
            width: '90%',
            maxWidth: (_props_maxWidth = props.maxWidth) !== null && _props_maxWidth !== void 0 ? _props_maxWidth : 400,
            backgroundColor: 'white',
            marginHorizontal: 10
        },
        children: [
            /*#__PURE__*/ _jsxs(View, {
                row: true,
                style: {
                    justifyContent: 'space-between',
                    paddingVertical: 12,
                    paddingHorizontal: 20,
                    borderBottomWidth: 1,
                    borderColor: theme.color.gray600
                },
                children: [
                    props._onBack ? /*#__PURE__*/ _jsx(Button, {
                        icon: "arrow-left",
                        variant: "text",
                        onPress: props._onBack,
                        "aria-label": "Go back",
                        style: {
                            marginRight: 8
                        }
                    }) : null,
                    props.heading ? /*#__PURE__*/ _jsx(OldHeading, {
                        text: props.heading,
                        style: {
                            marginBottom: 0
                        }
                    }) : null,
                    /*#__PURE__*/ _jsx(Button, {
                        icon: "close",
                        variant: "text",
                        onPress: props.onRequestClose,
                        "aria-label": "Close modal"
                    })
                ]
            }),
            props.maxHeight ? /*#__PURE__*/ _jsx(ScrollView, {
                style: {
                    maxHeight: props.maxHeight
                },
                children: /*#__PURE__*/ _jsx(View, {
                    style: {
                        padding: 20,
                        zIndex: 1
                    },
                    onStartShouldSetResponder: function() {
                        Keyboard.dismiss();
                        return true;
                    },
                    children: props.children
                })
            }) : /*#__PURE__*/ _jsx(View, {
                style: {
                    padding: 20,
                    zIndex: 1
                },
                onStartShouldSetResponder: function() {
                    Keyboard.dismiss();
                    return true;
                },
                children: props.children
            }),
            props.buttonText && props.onPressButton ? /*#__PURE__*/ _jsx(View, {
                row: true,
                style: {
                    justifyContent: 'center',
                    paddingVertical: 12,
                    paddingHorizontal: 20,
                    borderTopWidth: 1,
                    borderColor: theme.color.gray600
                },
                children: /*#__PURE__*/ _jsx(Button, {
                    text: props.buttonText,
                    onPress: props.onPressButton
                })
            }) : null
        ]
    }));
}
